/**
 * `global/parkingQueueRules`: the "Regler för kön" text shown below the
 * Parkering tabs on the Kö tab. Latest only, overwritten on save; absent =
 * never written. Clearing stores `text: ''` so who cleared it stays known.
 */
export const PARKING_QUEUE_RULES_PATH = 'global/parkingQueueRules';

/** Same cap as database.rules.json. */
export const PARKING_QUEUE_RULES_MAX_LENGTH = 5000;

export interface ParkingQueueRules {
    text: string;
    updatedBy: string;
    updatedWhen: string;
}

export function parseParkingQueueRules(raw: unknown): ParkingQueueRules | null {
    if (!raw || typeof raw !== 'object') return null;
    const r = raw as Record<string, unknown>;
    if (typeof r.updatedBy !== 'string' || typeof r.updatedWhen !== 'string') return null;
    return { text: typeof r.text === 'string' ? r.text : '', updatedBy: r.updatedBy, updatedWhen: r.updatedWhen };
}
